import React from 'react';
import Icon from '@material-ui/core/Icon';
import { edos, getEdoName } from '../../funcs/vars';
import { IR, GraphLine, GraphDonut, PeopleGraph } from './interactivo';
export default class Category extends React.Component{
  state = {
    show: false
  }

  componentDidMount(){
    // window.addEventListener('cat_hide_all', () => this.setState({show: false}));
  }

  toggle(){
    window.dispatchEvent(new Event('cat_hide_all'));
    this.setState({
      show: !this.state.show
    })
  }

  render(){
    var cs = ['i_category'];
    if(this.props.classes){
      cs = [...cs, ...this.props.classes];
    }
    if(this.props.isDark){
      cs.push('is_dark');
    }
    if(!this.state.show){
      cs.push('is_hidden');
    }

    var bgs = this.props.bgs;
    var bg = 'linear-gradient(to bottom, '+bgs[0]+', '+bgs[1]+', '+bgs[0]+')';

    return(
      <div
        style={{
          background: bg
        }}
        className={cs.join(' ')}
      >
      <div className="page_container page_interactivo">
        <CategoryIntro {...this.props} show={this.state.show} onToggle={() => this.toggle()}/>
        </div>
      </div>
    )
  }
}

function getImpactoName(i){
  switch(i){
    case "ingresos":
      return 'la pérdida de ingresos, problemas financieros o necesidad de reubicarse';
    break;
    case "ruptura":
      return 'la ruptura de una relación personal';
    break;
    case "drogas":
    return 'el aumento en el consumo de alcohol o drogas';
    break;
    case "enfermedad":
    return 'una enfermedad derivada del estrés u otro problema de salud';
    break;
    default:
    return i;
    break;
  }
}

class CategoryIntro extends React.Component{
  render(){

    switch(this.props.k){
      case "laboral":
        var cfl = "Conflictos cotidianos de tipo laboral que se incluyen: despido injustificado, acoso laboral, lesiones o problemas de salud por un accidente o por condiciones inadecuadas en el trabajo, y falta de pagos, salarios atrasados y problemas para obtener beneficios.";
      break;
      case "familiar":
        var cfl = "Conflictos cotidianos de tipo familiar que se incluyen: dificultades para obtener pagos de pensión alimenticia para sus hijos, problemas relacionados con la custodia de sus hijos, amenazas o violencia física por parte de su pareja u otro miembro del hogar";
      break;
      case "civico":
        var cfl = "Conflictos cotidianos cívicos que se incluyen: Problemas con vecinos sobre límites, bardas, o árboles, Problemas con sus vecinos por ruido, mascotas, lugares de estacionamiento, basura o uso ilegal de los servicios, Problemas con pandillas, vandalismo, o por el consumo de alcohol o drogas en la calle.";
      break;
      case "consumidor":
        var cfl = "Conflictos cotidianos de consumidor y servicios que se incluyen: problemas relacionados con servicios deficientes o mal hechos, con reembolso de mercancías o productos dañados, cortes del servicio de agua potable, luz, teléfono, o problemas por facturaciones incorrectas.";
      break;
    }



    var cats = ['ingresos', 'ruptura', 'drogas', 'enfermedad'];
    var r = this.props.r;

    var cstas = this.props.or.cats[this.props.k];
    /* Más impactos */
    var rmi = r['problem_with_most_impactos'];
        rmi.impactos = parseFloat(rmi.impactos);
    var rmi_m = 0;
    var rmi_impacto = "";
    for(var key in rmi){
      if(cats.indexOf(key) > -1){
        var v = rmi[key];
            v = parseFloat(v);
        rmi_m = Math.max(v, rmi_m);
        if(rmi_m == v){
          rmi_impacto = key;
        }
      }
    }

    /* Edad */
    var rin = cstas.edad;
    var tmprin = {};
    for(var key in rin){
      if(key == "70_" || key == "60_69"){
        tmprin['60_'] = rin['60_69'];
      }else{
        tmprin[key] = rin[key];
      }
    }

    rin = tmprin;

    var rin_o = {};
    for(var key in rin){
      if(!rin_o[key]){
        rin_o[key] = [];
      }
      var rows = rin[key];
      rin_o[key].push(parseFloat(rows));
    }
    var rin_op = [];
    for(var key in rin_o){
      var p = 0;

      var e = rin_o[key];
      e.map(v => p += v);
      p = Math.round(p / e.length);
      if(key == this.props.or.age_group){
        var t = [<>El <strong>{p}%</strong> de personas de tu edad sufrió al menos una consecuencia negativa* a raíz de un conflicto {this.props.label}.</>];
      }
      rin_op.push([key, p]);
    }


    var edad = rin_op;

    /* Género */
    var rin = cstas.sexo;
    var rin_o = {};
    for(var key in rin){
      if(!rin_o[key]){
        rin_o[key] = [];
      }
      var rows = rin[key];
      rin_o[key].push(parseFloat(rows));
    }
    var rin_op = [];
    for(var key in rin_o){
      var p = 0;
      var e = rin_o[key];
      e.map(v => p += v);
      p = Math.round(p / e.length);
      if(key == this.props.or.gender){
        var genderplural = this.props.or.gender == 'mujer' ? 'mujeres' : 'hombres';
        var tg = [<><strong>{Math.round(p / 10)} de cada 10 {genderplural}</strong> sufren al menos una consecuencia negativa a raíz de un conflicto {this.props.label}</>];
      }
      rin_op.push([key, p]);
    }
    var gender= rin_op;
    var gk = {};
    gender.map(function(g){
      var i = [
        ["Sí sufre consecuencias", g[1]],
        ["No sufre consecuencias", 100 - g[1]]
      ];
      gk[g[0]] = i;
    })


    /* Mayor impacto */
    var mir = this.props.or.problems_by_group[this.props.k];

    var a = [
      [
        <>
        <div className="icc">
          <div className="icc_category category_toggle" onClick={() => this.props.onToggle()}>
            <img src={this.props.logo} />
            <div className="icc_arrow">
              <Icon>{this.props.show ? "keyboard_arrow_up" : "keyboard_arrow_down"}</Icon>
            </div>
          </div>
          {
            this.props.show ?
            <>
            <div className="icc_category_cover"><img src={this.props.cover} /></div>
            <div className="icc_title icc_title_hl">
              El conflicto* {this.props.label} más común al que se enfrentan personas como tú es: <strong>{mir.name}</strong>
            </div>

            </>
            : null
          }
        </div>
        {
          this.props.show ?
          <div className="icc_subd">
            *{cfl}
          </div>
          : null
        }

        </>
      ]
    ];

    var etitle = '';
    var gtitle = '';
    var entitle = '';
    var els = this.props.or.gender == 'mujer' ? 'las mujeres' : 'los hombres';
    switch(this.props.k){
      case "laboral":
      etitle = 'en el trabajo las personas';
      gtitle = '¿Cómo viven ' + els + ' los conflictos laborales?';
      entitle = '¿Qué pasa laboralmente en tu entidad?';
      break;
      case "familiar":
      etitle = 'en la familia las personas';
      gtitle = '¿Cómo viven ' + els + ' los conflictos familiares?';
      entitle = '¿Qué pasa familiarmente en tu entidad?';
      break;
      case "civico":
      etitle = 'en el entorno cívico las personas';
      gtitle = '¿Cómo viven ' + els + ' los conflictos cívicos?';
      entitle = '¿Qué pasa en tu entidad a nivel cívico?';
      break;
      case "consumidor":
      etitle = this.props.or.gender == 'mujer' ? 'las consumidoras' : 'los consumidores';
      gtitle = '¿Cómo viven ' + els + ' los conflictos de consumo?';
      entitle = '¿Qué pasa con el consumo en tu entidad?';
      break;
    }

    etitle = '¿A qué se enfrentan ' + etitle + ' de tu edad?';


    var b = [
      [
        <>
        <div className="icc">
         <div className="icc_category">{etitle}</div>
         <div className="icc_title">
           {t}
         </div>
        </div>
        <div className="icc_subd">
          *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
        </div>
        <GraphLine
          data={edad}
          colors={this.props.colors}
          highlight={this.props.or.age_group}
          isBar
          height={280}
        />

        </>
      ]
    ]

    var pcd = gk[this.props.or.gender][0][1];
        pcd = Math.round(pcd / 10);

    var c = [
      [
        <>
        <div className="icc">
         <div className="icc_category">{gtitle}</div>
         <div className="icc_title">
           {tg}*
         </div>
         <PeopleGraph highlight={pcd} />

        </div>
        <div className="icc_subd">
          *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
        </div>
        </>
      ]
    ]
    /* Estado */
    var edo = this.props.or.edo;
    var et = cstas.entidad;
    var gs = [];
    var gse = et;
    var gse_impactos = gse;

    var gs_a_keys = Object.keys(gse_impactos);
    var gs_a_x = gs_a_keys.indexOf(edo);

    var gs_a_v = gse_impactos[edo];

    var edoname = getEdoName(edo);

    var edos_bars = [];
    for(var key in gse_impactos){
      var v = gse_impactos[key];
      edos_bars.push([key, parseInt(v)]);
    }

    edos_bars = edos_bars.sort((a, b) => a[1] <= b[1] ? 1 : -1);


    var gs_a = (
                <>
                 <div className="icc">
                    <div className="icc_category">{entitle}</div>
                      <div className="icc_title">
                        En {edoname}, el {gs_a_v}%  de las personas encuestadas han sufrido consecuencias negativas* relacionadas a un conflicto {this.props.label}
                      </div>
                  </div>
                  <div className="icc_subd">
                    *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
                  </div>
                  <GraphLine
                    highlight={edo}
                    data={edos_bars}
                    colors={this.props.colors}
                    isHorizontal
                    l={"Porcentaje de consecuencias negativas"}
                  />
                 </>
               );
    gs.push(gs_a);

    return(
      <div className="category_section">
        <IR content={a} isMain/>
        {
          this.props.show ?
          <div className="category_section_content">
            <IR content={b} />
            <IR content={c} />
            <IR content={gs} />
          </div>
          : null
        }

      </div>
    )
  }
}
